<template>
    <div class="animated fadeIn">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <header class="card-header">
              <div class="d-flex">
                <strong class="align-self-center">Perguntas</strong>
              </div>
            </header>
            <div v-if="loading" class="loading-container">
              <RotateSquare
                class="loading-position animated fadeIn"
                size="60px"
              ></RotateSquare>
            </div>
            <div v-else class="card-body">
              <b-table
                :hover="true"
                responsive
                :items="itens"
                :fields="fields"
                striped
                :per-page="itensPorPagina"
                show-empty
                empty-text="Nenhuma pergunta encontrada."
              >
                <template v-slot:empty="scope">
                  <h4>{{ scope.emptyText }}</h4>
                </template>
                
                <template v-slot:cell(acoes)="data">
                  <div class="btn-group-sm">
                    <b-button
                      variant="warning"
                      style="margin-right: 10px"
                      title="Editar"
                      @click="Editar(data.item)"
                    >
                      <i class="fa fa-edit"></i>
                    </b-button>
                    
                  </div>
                </template>
              </b-table>
              <b-pagination
                v-model="pagina"
                :total-rows="total"
                :per-page="itensPorPagina"
                align="right"
                size="md"
                class="mt-2"
              ></b-pagination>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import RotateSquare from "../../components/RotateSquare";
  import QuestionService from "../../servico/QuestionService";
  
  export default {
    name: "Usuario",
    components: {
      RotateSquare
    },
    data() {
      return {
        loading: false,
        itens: [],
        pagina: 1,
        total: 0,
        itensPorPagina: 20,
        fields: [
          { key: "description", label: "Descrição", sortable: true },
          {
            key: "acoes",
            label: "Ações",
            sortable: false,
            thClass: "center, wd-120-px"
          }
        ]
      };
    },
    watch: {
      pagina: function (val) {
        this.ObterGrid(val);
      }
    },
    beforeMount() {
      this.ObterGrid(1);
    },
    methods: {
      Editar(question) {
        this.$router.push("/pergunta/editar/" + question.id);
      },
      ObterGrid(pagina) {
        this.loading = false;
  
        QuestionService.GetGrid(pagina)
          .then((response) => {
            this.loading = false;
            this.itens = response.data.itens;
            this.total = response.data.total;
            this.pagina = response.data.pagina;
            this.itensPorPagina = response.data.itensPorPagina;
          })
          .catch((erro) => {
            this.loading = false;
            this.$notify({
              data: erro.response.data.erros,
              type: "warn",
              duration: 5000
            });
          });
      }
    }
  };
  </script>
  